
<span class="banner banner-top" [ngStyle]="{'background': '#'+ prestation.couleur}" ></span>
<h3>{{prestation.nom}}</h3>
<app-themes-wrapper [themes]="prestation.themes" />

@if(prestation.description){
    <div class="description-container">
        <p class="description-short">{{prestation.description}}</p>
    </div>
}

<a [routerLink]="'/prestation/' + prestation.documentId">en savoir plus</a>

<img class="theme-icon" [src]="getImageUrl(prestation.icon.url)" alt="">
<span class="banner banner-bottom" [ngStyle]="{'background': '#'+ prestation.couleur}"></span>